<template>
  <exercicioPergunta :alternativas="alternativas"></exercicioPergunta>
</template>

<script>
import exercicioPergunta from '@/custom/exercicioPergunta'
var componentDefinition = {
  components: { exercicioPergunta },
  route: {
    name: 'COMPLETE-PERGUNTA',
    path: '/aluno/:idaluno/matricula/:idmatricula/bloco/:idbloco/complete/rodada/:rodada/pergunta/:refresh?',
    meta: {
      title: 'Complete a Lacuna',
      hasErrorHandler: true,
      pergunta: true,
      hidden: true
    }
  },
  computed: {
    alternativas: function () {
      var alternativas = []
      if (this.$dados.PERGUNTA.ALTERNATIVAS) {
        this.$dados.PERGUNTA.ALTERNATIVAS.map((title, index) => {
          alternativas.push({
            title: title,
            resposta: index + 1
          })
        })
        var j, x, i
        for (i = alternativas.length - 1; i > 0; i--) {
          j = Math.floor(Math.random() * (i + 1))
          x = alternativas[i]
          alternativas[i] = alternativas[j]
          alternativas[j] = x
        }
      }
      return alternativas
    }
  },
  methods: {
  }
}
export default componentDefinition
</script>
